import { Tooltip } from "@mui/material"
import { LineChart } from "@mui/x-charts"

const DetailedProgressGraphView = ({
  detailedProgress,
  activeButton,
  graphYAxisString,
  overallProgress,
  isOverallReport,
}: {
  detailedProgress: any[]
  activeButton: string
  graphYAxisString: string
  overallProgress: any
  isOverallReport: any
}) => {
  return (
    <div className="gap-[15px] h-[85%] flex justify-start relative pr-4 pb-4">
      <div className="flex flex-col-reverse gap-0 w-[21px] items-center justify-center bg-[#f8f8f8] text-[#636363] rounded-sm text-sm font-medium">
        <div className="w-[313px] text-center text-sm -rotate-90">{graphYAxisString}</div>
      </div>
      <div className="flex flex-col w-[100%] justify-end gap-4 relative">
        <div className="flex w-[308px] justify-around items-end h-[250px]">
          {activeButton === "Mentor Session" ? (
            overallProgress.mentor.mentorRatings.parameterRating.map((item: number) => {
              const height = overallProgress.mentor.mentorRatings.parameterRating.reduce(
                (acc: number, item: any) => Math.max(acc, item),
                0
              )
              const calculatedHeight = (item * 100) / height
              const dynamicHeightClass = `${calculatedHeight}%`
              return (
                <Tooltip title={(item / overallProgress.mentor.total).toFixed(2)} placement="top">
                  <div
                    style={{ height: dynamicHeightClass }}
                    className={`bg-[#152356] p-0 w-9 rounded-tl rounded-tr rounded-bl-sm rounded-br-sm ${dynamicHeightClass}`}
                  ></div>
                </Tooltip>
              )
            })
          ) : activeButton === "Class Streak" || activeButton === "Problems Solved Streak" ? (
            <div className="w-[350px] h-[350px] absolute top-10 ">
              <LineChart
                xAxis={[{ data: [0, 1, 2, 3, 4, 5, 6] }]}
                sx={{
                  "& path": {
                    strokeWidth: 1.5,
                  },
                  "& line": {
                    strokeWidth: 1,
                    strokeDasharray: "5 5",
                  },
                  "& g.MuiChartsAxis-root line": {
                    strokeWidth: 1,
                    strokeDasharray: "none",
                  },
                }}
                series={[
                  {
                    data:
                      activeButton === "Class Streak"
                        ? overallProgress.class.streakData
                        : overallProgress.problems.streakHistory,
                    color: "#2563eb",
                    showMark: true,
                  },
                ]}
                width={350}
                height={350}
                grid={{ vertical: true, horizontal: true }}
              />
            </div>
          ) : (
            detailedProgress.map((item: any) => {
              if (activeButton === "Mentor Sessions") {
                return <div className="bg-[#e3e3e3] h-1 w-9 rounded-tl rounded-tr rounded-bl-sm rounded-br-sm" />
              }
              let height = 0
              let calculatedHeight = 0
              let attempted: any = 0
              if (activeButton === "Problems Solved" || activeButton === "Problems Solving") {
                height = detailedProgress.reduce((acc: number, item: any) => Math.max(acc, item.progress.attempted), 0)
                calculatedHeight = (item.progress.attempted * 100) / height
                attempted = item.progress.attempted
              }
              if (activeButton === "Classes Scheduled") {
                if (item.progress.classes.present + item.progress.classes.absent === 0) {
                  height = 0
                } else {
                  height = item.progress.classes.present + item.progress.classes.absent
                  calculatedHeight = (item.progress.classes.present * 100) / height
                }
              }
              if (activeButton === "Exams") {
                if (item.progress.exams.averageTotalScore === 0) {
                  height = 0
                } else {
                  height = 100
                  calculatedHeight = item.progress.exams.averageScore
                }
              }
              const dynamicHeightClass = `${calculatedHeight}%`
              return height > 0 ? (
                activeButton === "Problems Solved" ? (
                  <Tooltip title={attempted} placement="top">
                    <div
                      style={{ height: dynamicHeightClass }}
                      className={`bg-[#152356] p-0 w-9 rounded-tl rounded-tr rounded-bl-sm rounded-br-sm ${dynamicHeightClass}`}
                    ></div>
                  </Tooltip>
                ) : (
                  <div
                    style={{ height: dynamicHeightClass }}
                    className={`bg-[#152356] p-0 w-9 rounded-tl rounded-tr rounded-bl-sm rounded-br-sm ${dynamicHeightClass}`}
                  ></div>
                )
              ) : (
                activeButton !== "Problems Solved" && activeButton !== "Problems Solving" && (
                  <div className="bg-[#e3e3e3] h-1 w-9 rounded-tl rounded-tr rounded-bl-sm rounded-br-sm" />
                )
              )
            })
          )}
        </div>
        <div className="flex justify-around">
          {!(activeButton === "Class Streak" || activeButton === "Problems Solved Streak") &&
            (activeButton === "Mentor Session"
              ? overallProgress.mentor.mentorRatings.parameterRating.map((_: any, index: number) => (
                  <div className="text-[#636363] text-[10px] font-normal">{`P${index + 1}`}</div>
                ))
              : activeButton === "Class Streak" || activeButton === "Problems Solved Streak"
                ? overallProgress.mentor.mentorRatings.parameterRating.map((_: any, index: number) => (
                    <div className="text-[#636363] text-[10px] font-normal">{`P${index + 1}`}</div>
                  ))
                : detailedProgress.map((item: any) => (
                    <div className="text-[#636363] text-[10px] font-normal">{item.name}</div>
                  )))}
        </div>
      </div>
    </div>
  )
}

export default DetailedProgressGraphView
